import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { Card, Skeleton } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { BarChart } from '@mui/x-charts/BarChart';

export default function MakeModel({ chartData, loading }) {
    const theme = useTheme();
    const makeModelData = chartData || [];

    return (
        <Card variant="outlined" sx={{ width: '100%', boxShadow: 2 }}>
            <CardContent>
                <Typography component="h2" variant="h6" gutterBottom fontWeight="medium">
                    Most Popular Electric Vehicles 🚗⚡
                </Typography>
                <Stack sx={{ justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                        Distribution by Make & Model
                    </Typography>
                </Stack>
                {makeModelData.length > 0 ? (
                    <BarChart
                        borderRadius={8}
                        height={350}
                        colors={[theme.palette.primary.main]}
                        series={[
                            {
                                data: makeModelData.map((d) => d.count),
                                label: 'Vehicle Count',
                                valueFormatter: (value) => `${(value || 0).toLocaleString()} vehicles`,
                            }
                        ]}
                        xAxis={[{
                            data: makeModelData.map((d) => d.makeModel),
                            scaleType: 'band',
                            tickLabelStyle: {
                                angle: 34,
                                textAnchor: 'start',
                                fontSize: 11,
                            },
                            categoryGapRatio: 0.4,
                        }]}
                        margin={{ left: 50, right: 20, top: 20, bottom: 90 }}
                        grid={{
                            horizontal: true,
                            vertical: false,
                            strokeDasharray: '3 3',
                            stroke: theme.palette.divider
                        }}
                        sx={{
                            '.MuiBarElement-root': {
                                fill: theme.palette.primary.main,
                            },
                        }}
                        slotProps={{
                            legend: {
                                hidden: true,
                            },
                        }}
                    />
                ) : (
                    <Skeleton variant="rectangular" height={350} sx={{ bgcolor: theme.palette.background.paper }} />
                )}
            </CardContent>
        </Card>
    );
}
